// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file client_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file client_type.proto.
 */
export const file_client_type: GenFile = /*@__PURE__*/
  fileDesc("ChFjbGllbnRfdHlwZS5wcm90bxIGZG9tYWluKvcBCgpDbGllbnRUeXBlEhcKE0NMSUVOVF9UWVBFX1VOS05PV04QABIUChBDTElFTlRfVFlQRV9URVNUEAESEwoPQ0xJRU5UX1RZUEVfV0VCEGQSFAoPQ0xJRU5UX1RZUEVfQU5EEMgBEhQKD0NMSUVOVF9UWVBFX0lPUxDSARIUCg9DTElFTlRfVFlQRV9FWFQQrAISGAoTQ0xJRU5UX1RZUEVfRVhUX0lPUxCtAhIUCg9DTElFTlRfVFlQRV9DTEkQkAMSFAoPQ0xJRU5UX1RZUEVfQkFLEJEDEh0KGENMSUVOVF9UWVBFX0JBRV9BVURJVExPRxD0A0JSChphcHAuaGV5bG9naW4uYW5kcm9pZC5wcm90b1ouZ2l0bGFiLmNvbS9jb3RlY2hkZS9tb25vcmVwby9iYWNrZW5kL2RvbWFpbi9wYqICA0hQQWIGcHJvdG8z");

/**
 * NOTE: Types here must also be added to clientinfo/clientinfo.go
 * NOTE: Types here must also be added to backend-client-web/src/util/stringifyClientType.ts
 *
 * @generated from enum domain.ClientType
 */
export enum ClientType {
  /**
   * Internal
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: CLIENT_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CLIENT_TYPE_TEST = 1;
   */
  TEST = 1,

  /**
   * Web
   *
   * @generated from enum value: CLIENT_TYPE_WEB = 100;
   */
  WEB = 100,

  /**
   * Mobile
   * Android
   *
   * @generated from enum value: CLIENT_TYPE_AND = 200;
   */
  AND = 200,

  /**
   * iOS
   *
   * @generated from enum value: CLIENT_TYPE_IOS = 210;
   */
  IOS = 210,

  /**
   * Ext
   *
   * @generated from enum value: CLIENT_TYPE_EXT = 300;
   */
  EXT = 300,

  /**
   * @generated from enum value: CLIENT_TYPE_EXT_IOS = 301;
   */
  EXT_IOS = 301,

  /**
   * Cli
   *
   * @generated from enum value: CLIENT_TYPE_CLI = 400;
   */
  CLI = 400,

  /**
   * @generated from enum value: CLIENT_TYPE_BAK = 401;
   */
  BAK = 401,

  /**
   * Bae
   *
   * @generated from enum value: CLIENT_TYPE_BAE_AUDITLOG = 500;
   */
  BAE_AUDITLOG = 500,
}

/**
 * Describes the enum domain.ClientType.
 */
export const ClientTypeSchema: GenEnum<ClientType> = /*@__PURE__*/
  enumDesc(file_client_type, 0);

